export const images = [
	'images/apartment/1.jpg',
	'images/apartment/2.jpg',
	'images/apartment/3.jpg',
	'images/apartment/4.jpg',
	'images/apartment/5.jpg',
	'images/apartment/6.jpg',
	'images/apartment/7.jpg',
	'images/apartment/8.jpg',
	'images/apartment/9.jpg',
	'images/apartment/10.jpg',
	'images/beach/1.jpg',
	'images/beach/2.jpg',
	'images/beach/3.jpg',
	'images/beach/4.jpg',
	'images/beach/5.jpg',
];

export const galleryPreview = [
	'images/apartment/1.jpg',
	'images/apartment/2.jpg',
	'images/apartment/3.jpg',
	'images/apartment/4.jpg',
	'images/apartment/5.jpg',
	'images/apartment/6.jpg',
];
